import { BlogState } from './blogReducer'

export const FETCH_BLOG_DATA = 'FETCH_BLOG_DATA'

export type FetchBlogData = {
  type: typeof FETCH_BLOG_DATA
  payload: BlogState
}
